module.exports = __webpack_public_path__ + "img/unodc_logo2.9b0fcc74.png";